"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NavigationTypes = exports.TitleSizes = void 0;

var _componentListCell = _interopRequireDefault(require("@doordash/component-list-cell"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TitleSizes = {
  Small: 'SMALL',
  Medium: 'MEDIUM',
  Large: 'LARGE'
};
exports.TitleSizes = TitleSizes;
var NavigationTypes = {
  Back: {
    icon: _componentListCell["default"].IconTypes.ArrowLeft,
    accessibilityLabel: 'Back'
  },
  Menu: {
    icon: _componentListCell["default"].IconTypes.Menu,
    accessibilityLabel: 'Menu'
  },
  Close: {
    icon: _componentListCell["default"].IconTypes.Close,
    accessibilityLabel: 'Close'
  },
  None: 'None'
};
exports.NavigationTypes = NavigationTypes;